import { updateSearchMaskValues } from 'app/store/thunk/general';
import { SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { getQueryString, getSearchMaskValuesFromQueryString } from 'app/functions';
import { requestSearch } from 'app/store/thunk/general';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from 'app/hooks/appHooks';

export const updateSearchParams = createAsyncThunk<
  void,
  void,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>('general/updateSearchParams', async (_, { dispatch }) => {
  const searchMaskValues = getSearchMaskValuesFromQueryString(
    getQueryString(),
  ) as SearchMaskMountOptions['initialSearchMaskValues'];

  await dispatch(updateSearchMaskValues(searchMaskValues));

  dispatch(requestSearch({ noRedirect: true }));
});
